import { ApiProperty } from '@nestjs/swagger';
import { DeliveryMethodEnum, DeliveryTermsEnum, ItemResponsibleEnum, PackaginTrimsEnum, PaymentMethodEnum, PaymentTermsEnum, SalesPersonEnum } from '@project-management-system/shared-models';

export class samplePoOrdersDto {
    @ApiProperty()
    id: number;

    @ApiProperty()
    buyerName: string;

    @ApiProperty()
    OrdersbuyerCode: string;

    @ApiProperty()
    salesPerson: SalesPersonEnum;

    @ApiProperty()
    itemResponsible: ItemResponsibleEnum;

    @ApiProperty()
    deliveryTerms: DeliveryTermsEnum;

    @ApiProperty()
    discountOne: string;

    @ApiProperty()
    discountTwo: string;

    @ApiProperty()
    packagingTrims: PackaginTrimsEnum;

    @ApiProperty()
    deliveryMethod: DeliveryMethodEnum;

    @ApiProperty()
    paymentMethod: PaymentMethodEnum;

    @ApiProperty()
    paymentTerms: PaymentTermsEnum;

}